import { asyncActionStart, asyncActionFinish, asyncActionError } from '../../common/async/asyncActionStart';
import { toastr } from 'react-redux-toastr';

export const addSectors = (sector) => {
	return async (dispatch, getState, { getFirebase }) => {
		const firebase = getFirebase();
		try {
			dispatch(asyncActionStart());
			await firebase.push('sectors', sector);
			dispatch(asyncActionFinish());
		} catch (error) {
			console.error(error);
			if (error) {
				dispatch(asyncActionError());
				toastr.error('Adding data error', 'Data was not added');
			}
		}
	};
};

export const addSubCategories = (subcategory) => {
	return async (dispatch, getState, { getFirebase }) => {
		const firebase = getFirebase();
		try {
			dispatch(asyncActionStart());
			await firebase.push('subcategories', subcategory);
			toastr.success('Success', 'subcategory was added');
			dispatch(asyncActionFinish());
		} catch (error) {
			console.error(error);
			if (error) {
				dispatch(asyncActionError());
				toastr.error('Adding data error', 'Data was not added');
			}
		}
	};
};

export const addComplaintTypes = (complaintType) => {
	return async (dispatch, getState, { getFirebase }) => {
		const firebase = getFirebase();
		try {
			dispatch(asyncActionStart());
			await firebase.push('complaintTypes', complaintType);
			toastr.success('Success', 'Complaint Type was added');
			dispatch(asyncActionFinish());
		} catch (error) {
			console.error(error);
			if (error) {
				dispatch(asyncActionError());
				toastr.error('Adding data error', 'Data was not added');
			}
		}
	};
};

export const deleteItem = (path, key) => {
	//console.log(path, key);
	return async (dispatch, getState, { getFirebase }) => {
		const firebase = getFirebase();
		try {
			dispatch(asyncActionStart());
			await firebase.remove(path + key);
			toastr.success('Success', 'Item was deleted');
			dispatch(asyncActionFinish());
		} catch (error) {
			console.error(error);
			if (error) {
				dispatch(asyncActionError());
				toastr.error('Adding data error', 'Data was not added');
			}
		}
	};
};

export const addCategory = (category) => {
	return async (dispatch, getState, { getFirebase }) => {
		const firebase = getFirebase();
		try {
			dispatch(asyncActionStart());
			await firebase.push('categories', category);
			toastr.success('Success', 'Category was added');
			dispatch(asyncActionFinish());
		} catch (error) {
			console.error(error);
			if (error) {
				dispatch(asyncActionError());
				toastr.error('Adding data error', 'Data was not added');
			}
		}
	};
};
